import React, { Component } from 'react';
import Rodal from 'rodal';
import 'rodal/lib/rodal.css';
import analytics from 'rewind-analytics';

import OtherTopics from '../OtherTopics/OtherTopics';
import Chart from '../Chart/Chart';
import { withContext } from '../../App';

import './styles.scss';

class Modal extends Component {
  constructor(props) {
    super(props);

    this.state = { slideIndex: -1 };
  }

  // Disable scrolling when modal is open
  componentDidMount() {
    document.documentElement.style.position = 'fixed';
    document.documentElement.style.width = '100%';
  }

  // Enable scrolling when modal is closed
  componentWillUnmount() {
    document.documentElement.style.position = '';
    document.documentElement.style.width = '';
  }

  trackClick(option){
    const { topic } = this.props;

    analytics.count({
      groupName: `modal`,
      eventName: `Modal option - ${option} in ${topic}`,
      unique: true
    });
  }

  render() {
    const { topic, context: { topicData, modalOpen, toggleModal, optionSelected } } = this.props;
    const { slideIndex } = this.state;

    return (
      <Rodal visible={modalOpen} onClose={() => toggleModal(null)} animation="slideUp">
        {
          optionSelected === 'yes' &&
          <div className="modal-content">
            {
              slideIndex === -1 &&
              <div className={`yes-answer-wrapper ${topic}`}>
                <h2 style={{ color: 'green' }} className="mb-4">Yes</h2>
                <div dangerouslySetInnerHTML={{ __html: topicData[topic].yesAnswer }} />
                <div className="option-buttons">
                  {
                    topicData[topic].options &&
                    topicData[topic].options.map((option, index) => {
                      return (
                        <button key={index} className="option-button" onClick={() => { this.trackClick(option.title); this.setState({ slideIndex: index }) }}>
                          <span>{option.title}</span>
                        </button>
                      )
                    })
                  }
                </div>
              </div>
            }
            {
              // Selected slide render
              (topicData[topic].options && slideIndex !== -1) &&
              topicData[topic].options.map((option, index) => {
                if (index === slideIndex) {
                  return (
                    <React.Fragment key={index}>
                      <div className="modal-banner-image">
                        <img src={option.image} alt="" />
                        <div className="modal-banner-overlay" /> 
                        <div className="modal-banner-title">{option.title}</div>
                      </div>
                      <div className="modal-text-body" dangerouslySetInnerHTML={{ __html: option.content }} />
                      <Chart topic={topic} answer="yes" />
                      <OtherTopics />
                    </React.Fragment>
                  )
                }
                return null;
              })
            }
          </div>
        }
        {
          optionSelected === 'no' &&
          <div className="modal-content">
            <div className="no-answer-wrapper">
            <h2 style={{ color: '#B71C1C' }} className="mt-4 mb-4">No</h2>
            <div dangerouslySetInnerHTML={{ __html: topicData[topic].noAnswer }} />
            <Chart topic={topic} answer="no" />
            <OtherTopics />
            </div>
          </div>
        }
      </Rodal>
    );
  }
}

export default withContext(Modal);
